import React from 'react';
import {BoxBadge, BoxContainer, BoxMessage, BoxStatus} from '../styled';
import {Text} from '@phonectas/unifon-ui-kit';
import {useTranslation} from 'react-i18next';

interface UpsellMessageBoxProps {
    message: React.ReactNode;
    badgeText?: string | number;
    status?: BoxStatus;
}

const UpsellMessageBox: React.FC<UpsellMessageBoxProps> = ({
	message,
	badgeText,
	status = 'ok',
}) => {
	const [t] = useTranslation();
	return (
		<BoxContainer>
			<BoxMessage>
				<Text>{message}</Text>
			</BoxMessage>
			{badgeText && (
				<BoxBadge $status={status}>
					<Text>
						{`${t('Potentially in commission')}: ${badgeText},-`}
					</Text>
				</BoxBadge>
			)}
		</BoxContainer>
	);
};

export default UpsellMessageBox;
